jQuery(function($) {

  $(window).bind("load", function() {
    if($('#middle-target').length > 0) {

      var controller = new ScrollMagic.Controller();

      var sceneCopy = new ScrollMagic.Scene({
        triggerElement: "#grid-trigger"
      });

      var sceneGridItem1 = new ScrollMagic.Scene({
        triggerElement: "#grid-trigger"
      });

      var sceneGridItem3 = new ScrollMagic.Scene({
        triggerElement: "#grid-trigger"
      });

      var sceneArrow = new ScrollMagic.Scene({
        triggerElement: "#map-trigger"
      });

      var sceneNumber1 = new ScrollMagic.Scene({
        triggerElement: "#grid-trigger"
      });

      var sceneNumber2 = new ScrollMagic.Scene({
        triggerElement: "#grid-trigger"
      });

      var sceneNumber3 = new ScrollMagic.Scene({
        triggerElement: "#grid-trigger"
      });

      var sceneCircular = new ScrollMagic.Scene({
        triggerElement: "#map-trigger"
      });

      var sceneMap = createSceneMap();

      animateHero();

      if(mobileDevice()) {
        $('.district__resource__item').css('opacity', 1);
        $('.district__resource__item--2 svg').css('opacity', 1);
        $('.home__middle__copy.top').css('display', 'none');
        $('#home-middle-copy').css('opacity', 1);
        $('#home-middle-copy').css("margin-top", '48px');
        $('.home__middle__circular__graphic').css('display', 'none');
        $('.home__middle__district__resource').css('margin-top', '0');
      } else {
        // initialize skrollr
        skroll = skrollr.init({forceHeight: false});
        animateMiddle();
      }

      $(window).on('resize', function() {
        sceneMap.destroy(true);
        sceneMap = createSceneMap();
      });
    }

    function mobileDevice() {
      if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
        ){
        return true;
      } else {
        return false;
      }
    }
    function getDuration() {
      var start = $('#home-middle-map').offset().top;
      var end = $('.district__resource__item--2').offset().top;
      return end-start;
    }
    function createSceneMap() {
      return new ScrollMagic.Scene({
        triggerElement: "#home-middle-map",
        duration: getDuration()
      })
      .setPin("#home-middle-map", {pushFollowers: false})
      .addTo(controller);
    }

    function animateMiddle() {

      var tweenItem1 = TweenMax.to(".district__resource__item--1", .75, {opacity:1,ease:Power3.easeIn});
      var tweenItem3 = TweenMax.to(".district__resource__item--3", 1, {opacity:1,ease:Power3.easeIn});
      var tweenCopy = TweenMax.to("#home-middle-copy", .25, {opacity:1,ease:Power3.easeIn});

      var tweenCircular = TweenMax.to("#home-middle-circular-graphic", .75, {opacity:0,ease:Circ.easeOut});
      var tweenArrow = TweenMax.to(".home__middle__circular__graphic--arrow", .25, {opacity:0});

      var counter1 = { var: 0 };
      var tal1 = document.getElementById("district__resource__item__number--1");
      var tweenNumber1 = TweenMax.to(counter1, 3, {
          var: 6,
          onUpdate: function () {
            tal1.innerHTML = Math.ceil(counter1.var);
          },
          ease:Circ.easeOut
      });

      var counter2 = { var: 0 };
      var tal2 = document.getElementById("district__resource__item__number--2");
      tweenNumber2 = TweenMax.to(counter2, 2, {
          var: 10,
          onUpdate: function () {
            tal2.innerHTML = Math.ceil(counter2.var);
          },
          ease:Circ.easeOut
      });

      var counter3 = { var: 0 };
      var tal3 = document.getElementById("district__resource__item__number--3");
      tweenNumber3 = TweenMax.to(counter3, 1, {
          var: 1,
          onUpdate: function () {
            tal3.innerHTML = Math.ceil(counter3.var);
          },
          ease:Circ.easeOut
      });

      sceneCopy.setTween(tweenCopy);
      sceneCopy.addTo(controller);

      sceneGridItem1.setTween(tweenItem1);
      sceneGridItem1.addTo(controller);

      sceneGridItem3.setTween(tweenItem3);
      sceneGridItem3.addTo(controller);

      sceneArrow.setTween(tweenArrow);
      sceneArrow.addTo(controller);

      sceneNumber1.setTween(tweenNumber1);
      sceneNumber1.addTo(controller);

      sceneNumber2.setTween(tweenNumber2);
      sceneNumber2.addTo(controller);

      sceneNumber3.setTween(tweenNumber3);
      sceneNumber3.addTo(controller);

      sceneCircular.setTween(tweenCircular);
      sceneCircular.addTo(controller);
    }

    function animateHero() {
      if($('#hero-target').length > 0) {
        var controller = new ScrollMagic.Controller();

        var scene1 = new ScrollMagic.Scene({
          triggerElement: "#trigger1"
        });

        var scene2 = new ScrollMagic.Scene({
          triggerElement: "#trigger1"
        });

        var tweenSun = TweenMax.to(".home__hero__sun", 20, {
          rotation: 360,
          repeat: -1,
          yoyo: true,
          repeatDelay: 0,
        });

        var tweenBall = TweenMax.to(".home__hero__ball", 0.6, {
          transform: "translate3d(0px, -30px, 0px)",
          repeat: -1,
          yoyo: true,
          repeatDelay: 0,
          ease: Power1.easeOut
        });
        // var path = [{x:0, y:0}, {x:-60, y:-80}, {x:-144, y:-56}];
        // var tweenBall = TweenMax.to(".home__hero__ball", 3, {bezier:{curviness: 0.3, values:path}, scale:.5, ease:Power1.easeInOut})


        scene1.setTween(tweenSun);
        scene1.addTo(controller);

        scene2.setTween(tweenBall);
        scene2.addTo(controller);
      }

    }

  });

});
